import type { Screen0LanguageCode } from "@/features/language/language-registry";
import { getTranslations } from "@/i18n";

import { endOfWeek, parseDateKey, startOfMonth, startOfWeek } from "../../lib/dateNav";
import {
  formatEnglishDateLabel,
  formatEnglishMonthLabel,
  formatEnglishWeekRangeLabel,
  todayKey,
} from "../../lib/format";

export type PeriodMode = "day" | "week" | "month";

export function resolveTodayTopBarTitle(
  mode: PeriodMode,
  selectedDate: string,
  referenceDate = todayKey(),
  languageCode: Screen0LanguageCode = "en",
): string {
  const t = getTranslations(languageCode).today;

  if (mode === "day") {
    if (selectedDate === referenceDate) return t.titleToday;
    return formatEnglishDateLabel(parseDateKey(selectedDate), { languageCode });
  }

  if (mode === "month") {
    if (startOfMonth(selectedDate) === startOfMonth(referenceDate)) return t.titleThisMonth;
    return formatEnglishMonthLabel(selectedDate, { includeYear: true, languageCode });
  }

  const weekStart = startOfWeek(selectedDate);
  if (weekStart === startOfWeek(referenceDate)) return t.titleThisWeek;

  return formatEnglishWeekRangeLabel(weekStart, endOfWeek(selectedDate), {
    includeYear: true,
    languageCode,
  });
}
